import { Pipe, PipeTransform } from '@angular/core';
import { isRegExp, forEach } from 'lodash';
import { empty } from 'rxjs';

@Pipe({
  name: 'htmlencode',
  standalone: true
})
export class HtmlencodePipe implements PipeTransform {

  transform(str: string | null | undefined): string | null {
    if (str == null) return null;

    str = str.replace(/(\\r\\n|\\n|\r\n|\n|\r)/g, "<br/>");
    var rexp = new RegExp('<(?![^<]*>)', 'gm');
    var matches = rexp.test(str);
    
    var rexpTag = /<>/g;
    var emptytag: RegExpMatchArray | null = null;
    if (typeof str != "undefined" && str !== null)
      emptytag = str.match(rexpTag);
    if (emptytag) {
      forEach(emptytag, function (tag: string) {
        str = str?.replace(tag, '&lt;&gt;');
      });
    }

    if (matches) {
      return str.replace(rexp, '&lt;');
    }
    else return str;
  }

}




